import React from 'react';

const BonusCheckIcon = () => (
    <svg className="icon bonus-check-icon" viewBox="10 10 16 16">
        <defs>
            <filter id="a" filterUnits="objectBoundingBox">
                <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2.5" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>
        <g fill="none" fill-rule="nonzero" filter="url(#a)" transform="translate(10.25 10)">
            <path fill="#FFF" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Z" />
            <path
                fill="#32C24D"
                d="M10.957 4.983a.75.75 0 0 1 1.157.948l-.07.086-5 5.25a.75.75 0 0 1-1.024.06l-.077-.075-2.25-2.5a.75.75 0 0 1 1.034-1.08l.08.076 1.708 1.897 4.442-4.662Z"
            />
        </g>
    </svg>
);

export default BonusCheckIcon;
